import(/* webpackMode: "eager" */ "/codebuild/output/src647305449/src/src/app/global-error.tsx");
